<template lang="pug">
.scroller-container(:style="{ height: scale * 200 + 'px' }")
  .scroller(:style="{ transform: `scale(${100 * scale}%)` }")
    .found-container
      .loading(v-if="loading || error")
        .line(v-for="line in loadingLines", :style="{ top: line.top + 'px' }") {{ line.line }}
      div(v-else-if="found")
        .pre-lines
          .pre-lines-container
            .line(v-for="line in found.preLines") {{ line }}
        .line {{ found.preFound }}<span class="found" :style="{fontSize: Math.floor(100*found.fontSize)+'%'}">{{ found.found }}</span>{{ found.postFound }}
        .line(v-for="line in found.postLines") {{ line }}
      .error(v-if="error")
        | {{ error === true ? 'Oei, er liep iets fout. Probeer het later opnieuw.' : error }}

      .found-location(v-if="found && lookingFor.length")
        | Gevonden vanaf cijfer {{ format(location.position+1) }}
</template>

<script>
import loadingLinesDigits from "./loading_lines.json";

const digitsPerLine = 29;
const linesStart = 91;
const lineHeight = 18;
const minLinePosition = -30;

export default {
  props: {
    lookingFor: {
      type: String,
    },
    constant: {
      type: String,
      default: "pi",
    },
    maxHeight: {
      type: Number,
      default: 200,
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
  },
  created() {
    this.startLoadingCounter = 0;
    this.stopLoadingCounter = 0;
    this.loadingId = 0;
  },
  mounted() {
    this.startSearch();
  },
  data() {
    const nextDigits =
      "979323846264338327950288419716939937510582097494459230781640628620899862803482534211706798214808651328230664709384460955058223172535940812848111745028410270193852110555964462294895493038196442881097566593344612847564823378678316527120190914564856692346034861045432664821339360";
    const nextLines = [];

    for (let i = 0; i < nextDigits.length; i += digitsPerLine) {
      nextLines.push(nextDigits.substr(i, digitsPerLine));
    }

    return {
      loading: true,
      error: false,
      loadingLines: [],
      location: {
        position: 0,
        digits: "123456",
        fromStart: true,
      },
      nextDigits: nextLines,
    };
  },
  watch: {
    lookingFor() {
      this.startSearch();
    },
    constant() {
      this.startSearch();
    },
  },
  methods: {
    format(v) {
      v = "" + v;
      let r = [];
      while (v.length > 0) {
        r.push(v.substr(-3));
        v = v.substring(0, v.length - 3);
      }
      return r.reverse().join("\u2009");
    },
    startLoading() {
      if (this.startLoadingCounter++ > this.stopLoadingCounter) {
        if (this.error) {
          this.stopLoading();
          this.error = false;
        }
        return;
      }

      const loadingId = ++this.loadingId;
      this.loading = true;
      const loadingLines = [];
      for (let i = -8; i <= 8; ++i) {
        loadingLines.push({
          index: i,
          line: i < 0 ? "" : this.getLoadingLine(i),
          top: linesStart + i * lineHeight,
        });
      }
      this.loadingLines = loadingLines;

      const maxSpeed = 600;
      let speed = 0;
      let lastTime = +new Date();
      const onFrame = () => {
        if (loadingId != this.loadingId) return;
        if (
          this.loadingId != loadingId ||
          this.startLoadingCounter <= this.stopLoadingCounter
        ) {
          this.loading = false;
          return;
        }
        const time = +new Date();
        const dt = (time - lastTime) / 1000;
        speed += dt * (maxSpeed - speed);

        this.loadingLines.forEach((line) => {
          if ((line.top -= dt * speed) < minLinePosition) {
            line.index += loadingLines.length;
            line.top += loadingLines.length * lineHeight;
            line.line = this.getLoadingLine(line.index);
          }
        });

        lastTime = time;

        requestAnimationFrame(onFrame);
      };
      requestAnimationFrame(onFrame);
    },
    stopLoading() {
      ++this.stopLoadingCounter;
    },
    async startSearch() {
      try {
        this.startLoading();
        if (this.lookingFor.length > 6) {
          this.error = "Er kunnen hoogstens 6 cijfers gezocht worden.";
          return;
        }

        const lookingFor = this.lookingFor;
        const response = await fetch(
          "./data/find.php?needle=" +
            this.lookingFor +
            "&constant=" +
            this.constant
        );
        const json = await response.json();
        this.stopLoading();
        if (lookingFor == this.lookingFor) {
          this.location = json;
        }
      } catch (e) {
        this.error = true;
        console.error(e);
      }
    },
    getLoadingLine(i) {
      const lines = loadingLinesDigits[this.constant];
      let digits = lines ? lines[i] : "";
      if (!digits) {
        digits = "";
        while (digits.length < digitsPerLine)
          digits += Math.floor(10 * Math.random());
      }
      return digits;
    },
  },
  computed: {
    scale() {
      return Math.min(this.maxWidth / 280, this.maxHeight / 210);
    },
    found() {
      if (this.loading) return false;
      console.log(this.location);

      let digits = this.location.digits;
      const lookingFor = this.lookingFor
        ? this.lookingFor
        : this.location.digits.substr(0, 6);
      let start = digits.indexOf(lookingFor);
      let digitsFound = lookingFor.length;
      if (this.location.fromStart) {
        digits = digits[0] + "." + digits.substr(1);
        if (start > 0) ++start;
        else ++digitsFound;
      }
      let fontSize = 1.55;
      const foundSpace = Math.round(fontSize * digitsFound);
      const digitsTotal = digitsPerLine - foundSpace + digitsFound;
      const digitsBefore = Math.floor((digitsTotal - digitsFound) / 2);
      const lineStart = Math.max(0, start - digitsBefore);
      fontSize = foundSpace / digitsFound;
      const lineEnd = lineStart + digitsTotal;
      const postLines = [];
      for (let i = lineEnd; i < digits.length; i += digitsPerLine) {
        postLines.push(digits.substr(i, digitsPerLine));
      }
      const preLines = [];
      for (let i = lineStart; i > 0; i -= digitsPerLine) {
        preLines.splice(
          0,
          0,
          digits.substring(Math.max(0, i - digitsPerLine), i)
        );
      }

      return {
        preLines,
        preFound: digits.substring(lineStart, start),
        found: digits.substr(start, digitsFound),
        fontSize,
        postFound: digits.substring(start + digitsFound, lineEnd),
        postLines,
      };
    },
  },
};
</script>

<style scoped>
.scroller {
  margin: 10px auto 0;
  width: 280px;
  font-size: 16px;
  line-height: 20px;
  font-family: "Courier New", Courier, monospace;
  text-align: left;
  transform-origin: top center;
  height: 210px;
  position: relative;
}

.scroller:before,
.scroller:after {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  height: 61px;
  z-index: 10;
}
.scroller:before {
  top: -1px;
  background: linear-gradient(180deg, white, transparent);
}
.scroller:after {
  bottom: -1px;
  background: linear-gradient(0deg, white, transparent);
}

.found-container {
  height: 210px;
  overflow: hidden;
  position: relative;
}

.line {
  height: 18px;
}

.pre-lines {
  height: 91px;
  position: relative;
}

.pre-lines-container {
  position: absolute;
  bottom: 0;
}

.line .found {
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
}

.loading {
  position: relative;
}
.loading .line {
  position: absolute;
}

.error {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 70px 0 0 10px;
  color: rgb(218, 51, 51);
  background: rgba(255, 255, 255, 0.8);
}

.found-location {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  position: absolute;
  padding: 0 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  bottom: 0px;
  color: rgb(218, 51, 51);
  left: 3px;
  font-size: 11px;
  text-align: right;
  z-index: 20;
}
</style>
